export const API_URL = " https://admin.drpadmanabhavarma.com/api/v1/";
export const ASSETS_URL = " https://admin.drpadmanabhavarma.com/api/v1/";

// export const API_URL="";